<template>
  <div class="product-grid row-160-25">
    <!-- Real Grid -->
    <div class="product-grid-wrapper">
      <!-- Top List (Se 1 item, blocco orizzontale, se > 1 lista centrata) -->
      <div v-if="props.data?.topList?.length > 1" class="product-grid-top-list">
        <div v-for="item in props.data.topList" :key="item" class="product-grid-top-list-item">
          <div  v-if="item.image?.responsiveImage" class="product-grid-top-list-item-img">
            <WidgetPicture
              :image="{ custom: item.image?.responsiveImage }"
              :lazyLoad="true"
              :alt="item.image?.responsiveImage?.alt"
            />
          </div>

          <div v-if="item.text" class="product-grid-top-list-item-text" v-html="item.text" />
        </div>
      </div>
      <div v-else-if="props.data?.topList?.length === 1" class="product-grid-bottom --top-list">
        <div v-if="props.data?.topList[0]?.image?.responsiveImage" class="">
          <div class="product-grid-bottom-img">
            <WidgetPicture
              :image="{ custom: props.data?.topList[0]?.image?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.topList[0]?.image?.responsiveImage?.alt"
            />
          </div>
        </div>

        <div v-if="props.data?.topList[0]?.text" v-html="props.data?.topList[0].text" class="product-grid-bottom-text text-corpo-xxl " />
      </div>

      <!-- Header -->
      <div v-if="props.data?.header" class="product-grid-header">
          <div  v-if="props.data?.header?.leftImage?.responsiveImage" class="product-grid-header-img hide-for-small">
            <WidgetPicture
              :image="{ custom: props.data?.header.leftImage?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.header.leftImage?.responsiveImage?.alt"
            />
          </div>

          <div v-if="props.data?.header?.text" class="product-grid-header-text title-l-1" v-html="props.data.header.text" />

          <div  v-if="props.data?.header?.rightImage?.responsiveImage" class="product-grid-header-img hide-for-small">
            <WidgetPicture
              :image="{ custom: props.data?.header.rightImage?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.header.rightImage?.responsiveImage?.alt"
            />
          </div>
      </div>

      <!-- Main -->
      <div v-if="props.data?.main" class="product-grid-main">
        <div v-if="props.data?.main?.leftImage && props.data?.main?.leftText" class="product-grid-main-col left">
          <div v-if="props.data?.main?.leftText" class="product-grid-main-col-text" v-html="props.data?.main?.leftText" />

          <div v-if="props.data?.main?.leftImage?.responsiveImage" class="product-grid-main-col-img">
            <WidgetPicture
              :image="{ custom: props.data?.main?.leftImage?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.main?.leftImage?.responsiveImage?.alt"
            />
          </div>
        </div>

        <div v-if="props.data?.main?.centralImage?.responsiveImage" class="product-grid-main-col center">
          <div v-if="props.data?.main?.centralImage?.responsiveImage" class="product-grid-main-col-central-img">
            <WidgetPicture
              :image="{ custom: props.data?.main?.centralImage?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.main?.centralImage?.responsiveImage?.alt"
            />
          </div>
        </div>

        <div v-if="props.data?.main?.rightImage && props.data?.main?.rightText" class="product-grid-main-col right">
          <div v-if="props.data?.main?.rightText" class="product-grid-main-col-text" v-html="props.data?.main?.rightText" />

          <div v-if="props.data?.main?.rightImage?.responsiveImage" class="product-grid-main-col-img">
            <WidgetPicture
              :image="{ custom: props.data?.main?.rightImage?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.main?.rightImage?.responsiveImage?.alt"
            />
          </div>
        </div>
      </div>

      <!-- Bottom -->
      <div v-if="props.data?.bottom" class="product-grid-bottom">
        <div v-if="props.data?.bottom.text" v-html="props.data?.bottom.text" class="product-grid-bottom-text text-corpo-xxl " />

        <div v-if="props.data?.bottom?.image?.responsiveImage" class="">
          <div class="product-grid-bottom-img">
            <WidgetPicture
              :image="{ custom: props.data?.bottom?.image?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.data?.bottom?.image?.responsiveImage?.alt"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- CTA -->
    <div v-if="props.data?.cta?.label && props.data?.cta?.linkUrl" class="product-grid-cta">
      <WidgetArrowLink
        :label="props.data?.cta?.label"
        :link="props.data?.cta?.linkUrl"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesProductGrid',
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
